import clsx from "clsx";
import React, { useReducer, useEffect, useCallback } from "react";
import Select from "react-select";

const Filters = ({ posts, setFilteredPosts, children }) => {
  const getCategories = (posts) => new Set(posts.map((post) => post.post_type));

  const getSubcategories = (posts) => {
    const terms = [];
    posts.forEach((post) => {
      post.terms &&
        post.terms.forEach((term) => {
          terms.push(term.name);
        });
    });
    return new Set(terms);
  };

  const getTags = (posts) => {
    const allTagUniqueIds = [];
    posts.forEach((post) => {
      if (!post.tags) return;
      allTagUniqueIds.push(...post.tags.map((tag) => tag.term_id));
    });
    const uniqueTagIds = [...new Set(allTagUniqueIds)];

    const allTags = [];
    posts.forEach((post) => post.tags && allTags.push(...post.tags));
    return uniqueTagIds.map((id) => allTags.find((tag) => tag.term_id === id)).sort((a, b) => a.name.localeCompare(b.name));
  };

  const initFilters = () => ({
    categories: (() => {
      const catObj = {};
      getCategories(posts).forEach((cat) => {
        catObj[cat] = false;
      });
      return catObj;
    })(),
    subcategories: (() => {
      const catObj = {};
      getSubcategories(posts).forEach((cat) => {
        catObj[cat] = false;
      });
      return catObj;
    })(),
    tags: (() => {
      const tagObj = {};
      getTags(posts).forEach((tag) => {
        tagObj[tag.term_id] = false;
      });
      return tagObj;
    })(),
    selectedTags: [],
  });

  const reducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
      case "FILTER_CATEGORY":
        return {
          ...state,
          categories: {
            ...state.categories,
            [payload]: !state.categories[payload],
          },
        };
      case "FILTER_SUBCATEGORY":
        return {
          ...state,
          subcategories: {
            ...state.subcategories,
            [payload]: !state.subcategories[payload],
          },
        };
      case "FILTER_TAG":
        const newTags = {};
        getTags(posts).forEach((tag) => {
          state.selectedTags.forEach((selectedTag) => {
            if (tag.term_id === selectedTag.value) {
              newTags[tag.term_id] = true;
            } else {
              newTags[tag.term_id] = false;
            }
          });
        });
        return {
          ...state,
          tags: (() => {
            const tagObj = {};
            getTags(posts).forEach((tag) => {
              tagObj[tag.term_id] = payload.find((selectedTag) => selectedTag.value === tag.term_id) ? true : false;
            });
            return tagObj;
          })(),
          selectedTags: payload,
        };
      case "CLEAR_FILTER":
        return initFilters();
      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(reducer, initFilters());

  const filterPosts = useCallback(
    (posts) => {
      // const categoryFilters = state.categories;
      const subcategoryFilters = state.subcategories;
      const tagFilters = state.tags;

      // let filteredPosts = posts.filter((post) => {
      //   if (Object.values(categoryFilters).some((filter) => filter)) {
      //     if (categoryFilters[post.post_type] === false) return false;
      //   }
      //   return true;
      // });

      let filteredPosts = posts.filter((post) => {
        if (Object.values(subcategoryFilters).some((filter) => filter)) {
          const postSubcategories = post.terms && post.terms.map((term) => term.name);
          let subcategoryMatch = false;
          postSubcategories &&
            postSubcategories.forEach((subcategory) => {
              if (subcategoryFilters[subcategory] === true) subcategoryMatch = true;
            });
          if (subcategoryMatch) return true;
          return false;
        } else return true;
      });

      filteredPosts = filteredPosts.filter((post) => {
        if (Object.values(tagFilters).some((filter) => filter)) {
          const postTagIds = post.tags && post.tags.map((tag) => tag.term_id);
          if (!postTagIds) return false;
          let tagFilterPassed = false;
          postTagIds.forEach((tagId) => {
            if (tagFilters[tagId] === true) tagFilterPassed = true;
          });
          if (tagFilterPassed === false) return false;
        }
        return true;
      });

      return filteredPosts;
    },
    [state]
  );

  useEffect(() => {
    setFilteredPosts(filterPosts(posts));
  }, [state, posts, filterPosts, setFilteredPosts]);

  return (
    <div className="filters">
      {/* <div className="filters__categories">
        <h3>Kategorie</h3>
        {[...getCategories(posts)].map((category) => (
          <button
            key={category}
            onClick={() => dispatch({ type: "FILTER_CATEGORY", payload: category })}
            className={clsx(state.categories[category] && "selected", "mr-2", "categoryBtn")}
          >
            {category.charAt(0).toUpperCase() + category.slice(1)}
          </button>
        ))}
      </div> */}

      <div className="filters__categories mb-4">
        {/* <h3>Podkategorie</h3> */}
        {[...getSubcategories(posts)].map((subcategory) => (
          <button
            key={subcategory}
            onClick={() => dispatch({ type: "FILTER_SUBCATEGORY", payload: subcategory })}
            className={clsx("mr-2 subcategoryBtn ", state.subcategories[subcategory] && "selected")}
          >
            {subcategory.charAt(0).toUpperCase() + subcategory.slice(1)}
          </button>
        ))}
      </div>

      <div className="filters__tags mb-4 z-[8] relative">
        <h3 className={clsx("mt-4")}>Czego szukasz?</h3>
        <Select
          isMulti
          placeholder="Wybierz tagi aby filtrować punkty na mapie"
          value={state.selectedTags}
          onChange={(selected) => dispatch({ type: "FILTER_TAG", payload: selected })}
          options={getTags(posts).map((tag) => ({ value: tag.term_id, label: tag.name }))}
          aria-label="Wybierz tagi aby filtrować punkty na mapie"
        />
      </div>

      <div>{children}</div>
    </div>
  )
};

export default Filters;
